import {
  combineReducers
} from "redux";
import {
  AUTH_LOGIN_CHECK_TOKEN,
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_LOGOUT_REQUEST,
  AUTH_LOGOUT_SUCCESS,
  AUTH_LOGOUT_FAILURE,
  AUTH_LOGIN_CHECK_FAILURE
} from "store/state/auth";
import {
  AVP_FETCH_REQUEST,
  AVP_FETCH_SUCCESS,
  AVP_FETCH_FAILURE
} from "store/state/avp";
import {
  DEALS_FETCH_REQUEST,
  DEALS_FETCH_SUCCESS,
  DEALS_FETCH_FAILURE,
  DEAL_CREATE_REQUEST,
  DEAL_CREATE_SUCCESS,
  DEAL_CREATE_FAILURE,
  DEAL_FETCH_REQUEST,
  DEAL_FETCH_SUCCESS,
  DEAL_FETCH_FAILURE,
  DEAL_UPDATE_REQUEST,
  DEAL_UPDATE_SUCCESS,
  DEAL_UPDATE_FAILURE,
  DEAL_DELETE_REQUEST,
  DEAL_DELETE_SUCCESS,
  DEAL_DELETE_FAILURE,
  DEALS_FEATURE_IMAGE_UPLOAD_REQUEST,
  DEALS_FEATURE_IMAGE_UPLOAD_SUCCESS,
  DEALS_FEATURE_IMAGE_UPLOAD_FAILURE,
  DEALS_FETCH_REQUEST_STATUS,
  DEALS_FETCH_SUCCESS_STATUS,
  DEALS_FETCH_FAILURE_STATUS
  ,
  DEALS_FILE_UPLOAD_REQUEST,
  DEALS_FILE_UPLOAD_SUCCESS,
  DEALS_FILE_UPLOAD_FAILURE
} from "store/state/deal";
import {
  FUNDS_FETCH_REQUEST,
  FUNDS_FETCH_SUCCESS,
  FUNDS_FETCH_FAILURE
} from "store/state/fund";
import {
  PROPERTY_FETCH_REQUEST,
  PROPERTY_FETCH_SUCCESS,
  PROPERTY_FETCH_FAILURE
} from "store/state/property";
import {
  LIBOR_FILE_UPLOAD_REQUEST,
  LIBOR_FILE_UPLOAD_SUCCESS,
  LIBOR_FILE_UPLOAD_FAILURE,
  LIBOR_GET_REQUEST,
  LIBOR_GET_SUCCESS,
  LIBOR_GET_FAILURE
} from "store/state/libor";
import {
  BANK_SWAP_CALCULATE_REQUEST,
  BANK_SWAP_CALCULATE_FAILURE,
  BANK_SWAP_CALCULATE_SUCCESS,
  BANK_SWAP_GET_REQUEST,
  BANK_SWAP_GET_FAILURE,
  BANK_SWAP_GET_SUCCESS
} from "store/state/calculators/bankSwap";
import {
  CALCULATE_CAP
} from "store/state/calculators/capPricer";
import {
  RESET_LOAN_CASHFLOW_OVERRIDES,
  GET_DEAL_CASHFLOWS
} from "store/state/cashflows";
import {
  CASH_FLOWS_CALCULATE_REQUEST,
  CASH_FLOWS_CALCULATE_FAILURE,
  CASH_FLOWS_CALCULATE_SUCCESS,
  CASH_FLOWS_GET_REQUEST,
  CASH_FLOWS_GET_FAILURE,
  CASH_FLOWS_GET_SUCCESS
} from "store/state/calculators/cashFlows";
import {
  ADD_FILE_TO_LOAN,
  LOAN_ADD
} from "store/state/loan/loan";
import {
  LOAN_DETAIL_POST_ATTACHMENT
} from "pages/loanDetail/loanDetail.store";
import {
  QUOTE_DETAIL_POST_ATTACHMENT
} from "pages/quoteDetail/quoteDetail.store";
import {
  DEAL_POST_ATTACHMENT
} from "pages/deal/deal.store";
import {
  HEDGE_DETAIL_POST_ATTACHMENT
} from "pages/hedgeDetail/hedgeDetail.store";

import { LOAN_DETAILS_FILE_UPLOAD } from "./loan/loanDetails";

import { makePayload, generateDefaultActions } from "../utils/helpers";

export const REDIRECT = generateDefaultActions("REDIRECT");
export const initiateRedirect = () => makePayload(REDIRECT.value);


/**
 * Create a reducer which sets the loading status.
 *
 * @param {String} request - The request constant to use
 * @param {String} success - The success constant to use
 * @param {String} failure - The failure constant to use
 * @return {function} a reducer
 */
export function makeReducer(request, success, failure) {
  return function reducer(state = false, action) {
    if (action.type === request) {
      return true;
    } else if (action.type === success || action.type === failure) {
      return false;
    }

    return state;
  };
}

/**
 * Create a reducer which sets the loading status, based on multiple actions.
 *
 * @param  {Array.String} startActions - Actions that intiate loading
 * @param  {Array.String} finishActions - Actions that stop loading
 * @return {Function}
 */
export function makeMultiActionReducer(startActions, finishActions) {
  let counter = 0;

  return function reducer(state = false, action) {
    if (startActions.indexOf(action.type) !== -1) {
      counter = counter + 1;
    } else if (finishActions.indexOf(action.type) !== -1 && counter > 0) {
      counter = counter - 1;
    } else {
      return state;
    }

    return counter > 0;
  };
}

export default combineReducers({
  authentication: makeMultiActionReducer(
    [AUTH_LOGIN_CHECK_TOKEN, AUTH_LOGIN_REQUEST, AUTH_LOGOUT_REQUEST],
    [
      AUTH_LOGIN_SUCCESS,
      AUTH_LOGIN_FAILURE,
      AUTH_LOGOUT_SUCCESS,
      AUTH_LOGOUT_FAILURE,
      AUTH_LOGIN_CHECK_FAILURE
    ]
  ),
  avp: makeReducer(AVP_FETCH_REQUEST, AVP_FETCH_SUCCESS, AVP_FETCH_FAILURE),
  deal: makeMultiActionReducer(
    [
      DEALS_FETCH_REQUEST,
      DEAL_FETCH_REQUEST,
      DEAL_CREATE_REQUEST,
      DEAL_UPDATE_REQUEST,
      DEAL_DELETE_REQUEST,
      DEALS_FEATURE_IMAGE_UPLOAD_REQUEST
    ],
    [
      DEALS_FETCH_SUCCESS,
      DEAL_CREATE_SUCCESS,
      DEAL_FETCH_SUCCESS,
      DEAL_UPDATE_SUCCESS,
      DEAL_DELETE_SUCCESS,
      DEALS_FEATURE_IMAGE_UPLOAD_SUCCESS,
      DEALS_FEATURE_IMAGE_UPLOAD_FAILURE,
      DEALS_FETCH_FAILURE,
      DEAL_CREATE_FAILURE,
      DEAL_FETCH_FAILURE,
      DEAL_UPDATE_FAILURE,
      DEAL_DELETE_FAILURE
    ]
  ),
  fund: makeReducer(
    FUNDS_FETCH_REQUEST,
    FUNDS_FETCH_SUCCESS,
    FUNDS_FETCH_FAILURE,
    FUNDS_FETCH_REQUEST,
    FUNDS_FETCH_SUCCESS,
    FUNDS_FETCH_FAILURE
  ),
  property: makeReducer(
    PROPERTY_FETCH_REQUEST,
    PROPERTY_FETCH_SUCCESS,
    PROPERTY_FETCH_FAILURE
  ),
  libor: makeMultiActionReducer(
    [LIBOR_FILE_UPLOAD_REQUEST, LIBOR_GET_REQUEST],
    [
      LIBOR_FILE_UPLOAD_FAILURE,
      LIBOR_FILE_UPLOAD_SUCCESS,
      LIBOR_GET_SUCCESS,
      LIBOR_GET_FAILURE
    ]
  ),
  libor_upload: makeReducer(LIBOR_FILE_UPLOAD_REQUEST, LIBOR_FILE_UPLOAD_SUCCESS, LIBOR_FILE_UPLOAD_FAILURE),
  loan_file_upload: makeReducer(ADD_FILE_TO_LOAN.value, ADD_FILE_TO_LOAN.success, ADD_FILE_TO_LOAN.failure, LOAN_DETAIL_POST_ATTACHMENT.value, LOAN_DETAIL_POST_ATTACHMENT.success, LOAN_DETAIL_POST_ATTACHMENT.failure, QUOTE_DETAIL_POST_ATTACHMENT.value, QUOTE_DETAIL_POST_ATTACHMENT.success, QUOTE_DETAIL_POST_ATTACHMENT.failure),
  deal_file_upload: makeReducer(DEAL_POST_ATTACHMENT.value, DEAL_POST_ATTACHMENT.success, DEAL_POST_ATTACHMENT.failure),
  hedge_file_upload: makeReducer(HEDGE_DETAIL_POST_ATTACHMENT.value, HEDGE_DETAIL_POST_ATTACHMENT.success, HEDGE_DETAIL_POST_ATTACHMENT.failure),
  loan: makeMultiActionReducer(([]), [,]),
  bankSwap: makeReducer(
    BANK_SWAP_CALCULATE_REQUEST,
    BANK_SWAP_CALCULATE_FAILURE,
    BANK_SWAP_CALCULATE_SUCCESS,
    BANK_SWAP_GET_REQUEST,
    BANK_SWAP_GET_FAILURE,
    BANK_SWAP_GET_SUCCESS
  ),
  cashFlows: makeReducer(
    CASH_FLOWS_CALCULATE_REQUEST,
    CASH_FLOWS_CALCULATE_FAILURE,
    CASH_FLOWS_CALCULATE_SUCCESS,
    CASH_FLOWS_GET_REQUEST,
    CASH_FLOWS_GET_FAILURE,
    CASH_FLOWS_GET_SUCCESS
  ),
  capPricer: makeReducer(
    CALCULATE_CAP.value,
    CALCULATE_CAP.success,
    CALCULATE_CAP.failure
  ),
  loanCashflows: makeReducer(
    RESET_LOAN_CASHFLOW_OVERRIDES.value,
    RESET_LOAN_CASHFLOW_OVERRIDES.success,
    RESET_LOAN_CASHFLOW_OVERRIDES.failure
  ),
  getDealCashflows: makeReducer(
    GET_DEAL_CASHFLOWS.value,
    GET_DEAL_CASHFLOWS.success,
    GET_DEAL_CASHFLOWS.failure
  ),
  pipeline: makeReducer(
    DEALS_FETCH_REQUEST_STATUS,
    DEALS_FETCH_SUCCESS_STATUS,
    DEALS_FETCH_FAILURE_STATUS
  ),
  dealAttachments: makeReducer(
    DEALS_FILE_UPLOAD_REQUEST,
    DEALS_FILE_UPLOAD_SUCCESS,
    DEALS_FILE_UPLOAD_FAILURE
  ),
  redirect: makeReducer(
    REDIRECT.value,
    REDIRECT.success,
    REDIRECT.failure
  )

});
